import React from "react";
import {
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Form,
  FormInput,
  FormGroup,
  Button,
  Alert
} from "shards-react";
import "../../assets/login.css";
import api from "../../api";
import { storeToken, getRole } from "../../utils/auth";

class LoginForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: '',
      showAlert: false,
      message: '',
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    api.post('/account/login', 
      {
        phone: this.state.username,
        password: this.state.password,
      }
    ).then(res => {
      if (!res.status) {
        this.setState({
          showAlert: true,
          message: res.message
        })
      } else {
        storeToken(res.token)
        if (getRole() === 'ADMIN' || getRole() === 'DEVELOPER' || getRole() === 'TEAM_LEADER') {
          window.location.href = '/dashboard';
        }
      }
    }).catch(() => {
      
    })
  }

  render() {
    return (
      <ListGroup flush>
        <Alert className="mb-3" open={this.state.showAlert} theme="warning">
          {this.state.message}
        </Alert>
        <ListGroupItem className="p-3">
          <Row>
            <Col>
              <Form>
                <FormGroup>
                  <label htmlFor="fePhone">Phone</label>
                  <FormInput
                    id="fePhone"
                    type="number"
                    placeholder="Phone"
                    value={this.state.username}
                    onChange={(e) => this.setState({username: e.target.value})}
                  />
                </FormGroup>
                <FormGroup>
                  <label htmlFor="fePassword">Password</label>
                  <FormInput
                    id="fePassword"
                    type="password"
                    placeholder="Password"
                    value={this.state.password}
                    onChange={(e) => this.setState({password: e.target.value})}
                  />
                </FormGroup>

                <Button className="btn-submit" type="submit" onClick={(e) => this.handleSubmit(e)}>Submit</Button>
              </Form>
            </Col>
          </Row>
        </ListGroupItem>
      </ListGroup>
    )
  }
};

export default LoginForm;
